import axios from "@/plugins/axios";



export async function validateToken() {
  try {
    await axios.get("/check-login"); 
    return true; 
  } catch (error) {
    if (error.response?.status === 401) {
      console.warn("Sesión expirada validando token");
    } else {
      console.error("Error de conexión al validar token", error);
    }
    return false;
  }
}